import React, {useState, useEffect} from "react";
import "./WeatherForecast.css";
import axios from "axios";
import WeatherForecastDay from "./WeatherForecastDay";

export default function WeatherForecast(props) {
    let[loaded, setLoaded] = useState(false);
    let[forecast, setForecast] = useState(null);
    
    // if the coordinates changed(New City) set loader to false.
    useEffect(() => {
        setLoaded(false);
    },[props.coordinates]);

    function handleResponse(response){

        setForecast(response.data.daily);
        setLoaded(true);

    }

    function load(params) {
        let apiKey = 'c50922829f85c8a60c3d5613f8ba6259';
        let longitude = props.coordinates.lon;
        let latitude = props.coordinates.lat;
        let apiURL = `https://api.openweathermap.org/data/2.5/onecall?lat=${latitude}&lon=${longitude}&appid=${apiKey}&units=metric`;
    
        axios.get(apiURL).then(handleResponse);
        
    }

    if(loaded) {
        
        return (
            <div className="WeatherForecast">
                <div className="row">
                    {forecast.map(function (dailyForecast,index) {
                        if(index<5){
                            return (
                                
                                    
                                    <div className="col" key = {index}>
                                        <WeatherForecastDay data = {dailyForecast}/>
                                    </div>
                             
                            );
                        } else {
                            return null;
                        }
                    })}   
                </div>
            </div>
        );
        
    } else {
        load();

        return null;
    }
    
}